"use strict";

exports.__esModule = true;

exports.default = function (strings, raw) {
  strings.raw = raw;
  return strings;
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/helpers/taggedTemplateLiteralLoose.js
// module id = 15
// module chunks = 168707334958949